import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import {useLocation,Redirect} from 'react-router-dom';
import {HashRouter as Router} from 'react-router-dom';
import './dx-styles.scss';
import {NavigationProvider} from './contexts/navigation';
import {TopNavigationProvider} from './contexts/top-navigation';
import {AuthProvider, useAuth} from './contexts/auth';
import {useScreenSizeClass} from './utils/media-query';
import AdminContent from './Content-admin';
import Content from './Content';
import NotAuthenticatedContent from './NotAuthenticatedContent';
import Session from './sessions';

const currentUser = () => {
    return Session.getSession("user");
}

function App() {
    const location = useLocation();
    const {user} = useAuth();
    var userRoles = currentUser()?.roles[0];
    //console.log("currentUser",currentUser());
    if(userRoles === "ROLE_ADMIN"){
        if(currentUser()){
            return (<AdminContent/>);
        }else{
            if(user)
                return (<AdminContent/>)
            else{
                return (<NotAuthenticatedContent/>)
            }
        }
    }else{
        if(currentUser()){
            return (<Content/>);
        }else{
            if(user)
                return (<Content/>)
            else{
                return (<NotAuthenticatedContent/>)
            }
        }
    }
    }
   

export default function () {
    const screenSizeClass = useScreenSizeClass();
  
    return (
        <Router>
            <AuthProvider>
                <NavigationProvider>
                    <TopNavigationProvider>
                        <div className={`app ${screenSizeClass}`}>
                            <App/>
                        </div>
                    </TopNavigationProvider>
                </NavigationProvider>
            </AuthProvider>
        </Router>
    )
}